import jQuery from 'jquery';

jQuery(function($) {
  let $tagLists = $('.tag-list');

  $tagLists.each(function() {
    let $tagList = $(this);
    let $tagListWrapper = $tagList.find('.tag-list__wrapper');

    if (
      !($tagListWrapper.height() < $tagListWrapper.get(0).scrollHeight
        || $tagListWrapper.width() < $tagListWrapper.get(0).scrollWidth)
    ) {
      return;
    }

    const expandText = $tagList.data('spoilerExpand');
    const collapseText = $tagList.data('spoilerCollapse');

    let $tagListSwitcher = $('<a>', {
      'href': 'javascript:void(0);',
      'class': 'tag-list__switcher',
      'text': expandText,
    });
    $tagList.append($tagListSwitcher);

    $tagListSwitcher.on('click', function() {
      let isCollapsed = $tagList.data('isCollapsed');

      $tagListSwitcher.text(isCollapsed ? expandText : collapseText);
      $tagListSwitcher.toggleClass('tag-list__switcher--collapse', !isCollapsed);

      $tagList.toggleClass('tag-list--expand', !isCollapsed);
      $tagList.data('isCollapsed', !isCollapsed);
    });
  });
});
